import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { GoogleApiWrapper } from 'google-maps-react';

import { GOOGLE_API_TOKEN } from '../../common/constants';
import HostelLocation from './HostelLocation';


export class GoogleMapsWrapper extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="common-google-maps-wrapper">
        <HostelLocation google={this.props.google} />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}
const MapWrapper = GoogleApiWrapper({
  apiKey: GOOGLE_API_TOKEN,
  libraries: ['visualization']
})(GoogleMapsWrapper);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapWrapper);



// WEBPACK FOOTER //
// ./src/features/common/GoogleMapsWrapper.js